module.exports = __webpack_public_path__ + "static/img/fazhanbanner.62f6c78a.png";